
import React, { useState } from 'react';
import { useApp } from '../context/AppContext';
import { X, Save, CloudUpload, Server } from 'lucide-react';

interface ProjectManagerProps {
  isOpen: boolean;
  onClose: () => void;
}

const ProjectManager: React.FC<ProjectManagerProps> = ({ isOpen, onClose }) => {
  const { syncWithServer } = useApp();
  const [isProcessing, setIsProcessing] = useState(false);

  const handleLiveSave = async () => {
      setIsProcessing(true);
      const success = await syncWithServer();
      setIsProcessing(false);
      if (success) {
          alert('Zmiany zostały zapisane na serwerze i są widoczne dla klientów.');
          onClose();
      }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[200] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4 animate-fade-in">
      <div className="bg-white rounded-xl shadow-2xl w-full max-w-lg overflow-hidden flex flex-col">
        {/* Header */}
        <div className="bg-gray-900 text-white p-4 flex justify-between items-center">
          <h2 className="text-lg font-bold flex items-center gap-2">
            <Server className="text-green-400" /> CMS: Zapis Zmian
          </h2>
          <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors">
            <X size={24} />
          </button>
        </div>

        {/* Content */}
        <div className="p-8 text-center space-y-6">
            <div className="w-20 h-20 bg-green-100 text-green-600 rounded-full flex items-center justify-center mx-auto shadow-sm animate-pulse-slow">
                <CloudUpload size={40} />
            </div>
            <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Zapisz wersję LIVE</h3>
                <p className="text-gray-500 text-sm leading-relaxed">
                    Twoje zmiany zostaną natychmiast wysłane do bazy danych serwera.<br/>
                    Klienci zobaczą zaktualizowaną stronę od razu po odświeżeniu.
                </p>
            </div>
            
            <button 
                onClick={handleLiveSave}
                disabled={isProcessing}
                className="w-full bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-lg font-bold text-sm uppercase tracking-widest shadow-lg transform hover:scale-105 transition-all disabled:opacity-50 disabled:scale-100 flex items-center justify-center gap-3"
            >
                {isProcessing ? 'Zapisywanie...' : <><Save size={18}/> Opublikuj Zmiany</>}
            </button>
            
            <p className="text-[10px] text-gray-400">
                Wymaga aktywnego połączenia z internetem i uprawnień administratora.
            </p>
        </div>
      </div>
    </div>
  );
};

export default ProjectManager;
